import React, { useState, useEffect } from 'react';
import RangeInputNumber from '../../molecules/Range/RangeInputNumber';
import RangeInputNumberLimit from '../../molecules/Range/RangeInputNumberLimit';
import ItemCheckBox from '../../atoms/CheckBox/ItemCheckBox';
import { GraphDispSetting } from './RawWaveformComparisonConanairChart';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';

type Props = {
  settingData: GraphDispSetting;
  onChange: (data: GraphDispSetting) => void;
};

const RawWaveformComparisonConanairChartSetting: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const buttonStyle = {
    maxWidth: '180px',
    maxHeight: '35px',
    minWidth: '180px',
    minHeight: '35px',
  };
  const xMinMaxOn = (min: number, max: number) => {
    console.debug(`min=${min},max=${max}`);
    var tmp = props.settingData;
    tmp.xMin = min;
    tmp.xMax = max;
    props.onChange(tmp);
  };
  const yMinMaxOn = (min: number, max: number, lineNo: number) => {
    console.debug(`min=${min},max=${max}`);
    var tmp = props.settingData;
    if (lineNo == 1) {
      tmp.y1Min = min;
      tmp.y1Max = max;
    } else {
      tmp.y2Min = min;
      tmp.y2Max = max;
    }

    props.onChange(tmp);
  };

  const onPileupChangeCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    var tmp = props.settingData;
    tmp.isPileup = tmp.isPileup == true ? false : true;
    props.onChange(tmp);
  };
  const onDCRemovalChangeCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    var tmp = props.settingData;
    tmp.isDCRemoval = tmp.isDCRemoval == true ? false : true;
    props.onChange(tmp);
  };

  return (
    <Box display="flex" justifyContent="flex-start" alignItems="flex-end">
      <div style={{ width: 310 }}>
        <RangeInputNumberLimit
          textBoxWidth={'70px'}
          limitValue={5000}
          label={t('RawWaveformComparisonConanairChartSetting.時間軸範囲', '時間軸範囲')}
          minValue={props.settingData.xMin}
          maxValue={props.settingData.xMax}
          minValueLimit={0}
          maxValueLimit={31459}
          onChange={xMinMaxOn}
        />
      </div>
      <div style={{ width: 310 }}>
        <RangeInputNumber
          textBoxWidth={'70px'}
          label={t('RawWaveformComparisonConanairChartSetting.振動幅範囲', '振動幅範囲')}
          minValue={props.settingData.y1Min}
          maxValue={props.settingData.y1Max}
          minValueLimit={-999.999}
          maxValueLimit={999.999}
          onChange={(max, min) => yMinMaxOn(max, min, 1)}
        />
        <RangeInputNumber
          textBoxWidth={'70px'}
          label={t('RawWaveformComparisonConanairChartSetting.振動幅範囲2軸', '振動幅範囲2軸')}
          minValue={props.settingData.y2Min}
          maxValue={props.settingData.y2Max}
          minValueLimit={-999.999}
          maxValueLimit={999.999}
          onChange={(max, min) => yMinMaxOn(max, min, 2)}
        />
      </div>
      <ItemCheckBox
        labelPosition={2}
        value={props.settingData.isPileup}
        label={t('RawWaveformComparisonConanairChartSetting.重ね合わせ', '重ね合わせ')}
        onChangeEvent={onPileupChangeCheckBox}
      />
      <ItemCheckBox
        labelPosition={2}
        value={props.settingData.isDCRemoval}
        label={t('RawWaveformComparisonConanairChartSetting.直流成分除去', '直流成分除去')}
        onChangeEvent={onDCRemovalChangeCheckBox}
      />
    </Box>
  );
};

export default RawWaveformComparisonConanairChartSetting;
